import { BACKEND_URL } from "../lib/api";

/**
 * Resolve a relative /api/uploads/... URL to a fully-qualified URL that the
 * browser can fetch through the ingress.
 */
export function resolveImage(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
}
